var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.9012 1.41406C7.04537 1.41406 5.53662 2.92281 5.53662 4.77865C5.53662 6.59906 6.96037 8.07239 8.8162 8.13615C8.87287 8.12906 8.92954 8.12906 8.97204 8.13615C8.9862 8.13615 8.99329 8.13615 9.00745 8.13615C9.01454 8.13615 9.01454 8.13615 9.02162 8.13615C10.835 8.07239 12.2587 6.59906 12.2658 4.77865C12.2658 2.92281 10.757 1.41406 8.9012 1.41406Z",
    fill: "#2E37A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4996 10.0194C10.5233 8.70187 7.30038 8.70187 5.30997 10.0194C4.41038 10.6215 3.91455 11.436 3.91455 12.3073C3.91455 13.1785 4.41038 13.986 5.30288 14.581C6.29455 15.2469 7.59788 15.5798 8.90122 15.5798C10.2046 15.5798 11.5079 15.2469 12.4996 14.581C13.3921 13.979 13.8879 13.1715 13.8879 12.2931C13.8808 11.4219 13.3921 10.6144 12.4996 10.0194Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f39348996604e5ba45febbf31f9d1828.svg";
export { ForwardRef as ReactComponent };